<template>
  <header>
    <el-row class="row-bg header-div" justify="center">
      <el-col :span="20" style="display: flex;justify-content: space-between;align-items: center;">
        <router-link to="/">
          <img class="logo_img" src="https://cdn.rokit.gg/web-img/logo.png">
        </router-link>
        <!-- <div v-if="login===false" class="login" @click="subscribeClick" @mousedown="monitor" @mouseup="log('login')">
          Log in
        </div>
        <div v-if="login===true" class="header-img">
          <img class="google-img" :src="headerImg" @click="clickHeader">
          <div v-if="showLoginOut" class="header-login-out-div">
            <div @mouseover="setBackGroundColor" @mouseout="setBackGroundColorOut" @click="subscribeClick" class="header-login-out" @mouseup="log('logSubscription')">Subscription</div>
            <div @mouseover="setBackGroundColor" @mouseout="setBackGroundColorOut" @click="logOut" class="header-login-out"  @mouseup="log('logout')">Log out</div>
          </div>
        </div> -->
      </el-col>
    </el-row>
  </header>
</template>

<script>
import {onMounted, ref} from "vue";
import Cookies from "js-cookie";
import axios from "axios";
import {clickLog, getCommonHeader, sleep} from "@/js/common";
import {rootDomain, serverHost} from "@/js/config";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Header',
  props: {
    msg: String
  },
  setup() {
    let beginMonitor = ref(false)
    let login = ref(false)
    let headerImg = ref('')
    let showLoginOut = ref(false)
    const setBackGroundColor = (e)=>{
      e.target.style.backgroundColor = '#e9e9e9'
    }
    const setBackGroundColorOut = (e)=>{
      e.target.style.backgroundColor = '#ffffff'
    }
    const logOut = ()=>{
      console.warn('aaaaa',window.location.origin+'/'+Cookies.get('identityId')+'/account')
      Cookies.remove('rokit-id-token',{path: '/', domain: rootDomain})
      Cookies.remove('logged-on',{path: '/', domain: rootDomain})
      Cookies.remove('identityId',{path: '/', domain: rootDomain})
      login.value = false
      showLoginOut.value = false
      if (window.location.href.endsWith('/account') || window.location.href.endsWith('/account#paypal')){
        window.location.href = '/'
      }
    }
    const log = (flag)=>{
      clickLog(flag)
    }
    const subscribeClick = () => {
      let identityId = Cookies.get('identityId');
      if (login.value && identityId){
        window.location.href = window.location.origin +'/'+ identityId + '/account'
      }else {
        window.open(serverHost+'v1/authenticate/loginWithGoogle', 'Login', "height=500, width=400, top=100, left=300, toolbar=no, menubar=no, scrollbars=no, resizable=no,location=no, status=no")
        beginMonitor.value = true
      }
    }
    const clickHeader = () => {
      showLoginOut.value = !showLoginOut.value
    }
    const tologin = () => {
      let token_id = Cookies.get('rokit-id-token')
      if (token_id) {
        axios.get(serverHost+'v1/account/basicInfo', {
          headers: getCommonHeader(),
        }).then(r => {
          headerImg.value = r.data.avatar
          login.value = true
          return true
        })
      }
      return false
    }
    tologin()
    const monitor = async () => {
      // eslint-disable-next-line no-constant-condition
      while (true) {
        let islogin = tologin()
        if (islogin){
          break
        }
        await sleep(3000)
      }
    }

    onMounted(() => {
      document.querySelector("div[id='app']").addEventListener('click',(e)=>{
        let className = e.target.className
        if (className !== 'google-img' && className !== 'header-login-out'){
          showLoginOut.value = false
        }
      })
    })
    return {subscribeClick,log,headerImg,login,clickHeader,showLoginOut,setBackGroundColor,setBackGroundColorOut,logOut,monitor}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
header{
  height: 80px;
  background-color:#0b0e10;
}
.header-login-out{
  padding: 5px 10px;
  border-radius: 8px;
  cursor: pointer;
}
.google-img{
  width: 100%;
  border-radius: 100px;
  cursor: pointer
}
.header-login-out-div{
  border-radius: 5px;
  position: absolute;
  background-color: #fff;
  color: black;
  margin-top: 10px;
}
.header-img{
  width: 50px;
}
.header-div{
  height: 80px;
  position: fixed;
  width: 100%;
  background-color: #0b0e10;
  z-index: 100;
}
.login{
  padding: 3px 10px;
  border-radius: 5px;
  cursor: pointer;
  border: solid 1px #ffffff;
}
.logo_img{
  cursor: pointer;
  height: 40px;
}
</style>
